/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardMessageFromDiscriminatorValue, type DashboardMessage } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetMessagesByFile
 */
export interface GetMessagesByFileRequestBuilder extends BaseRequestBuilder<GetMessagesByFileRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardMessage[]>}
     */
     get(requestConfiguration?: RequestConfiguration<GetMessagesByFileRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardMessage[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetMessagesByFileRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetMessagesByFileRequestBuilderGetQueryParameters {
    bookingNumber?: string;
    passengerDataFileId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetMessagesByFileRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetMessagesByFile?bookingNumber={bookingNumber}&passengerDataFileId={passengerDataFileId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetMessagesByFileRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetMessagesByFileRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardMessageFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
